export enum UserCategory {
    PRIMARY = "Primary",
    SECONDARY = "Secondary",
}

export enum WebStorageLocation {
    LOCAL = "LOCAL",
    SESSION = "SESSION",
}

export interface IPopupEntities {
    entities: Record<string, string>;
}

/**
 * Enhanced popup frequency capping storage structure
 * Scoped by tableId to handle table changes
 */
export interface IPopupFrequencyData {
    [tableId: string]: {
        entities: {
            [entityId: string]: {
                timestamp: string; // Timestamp when first shown (used for duration check)
                count: number; // Number of times shown within duration
                maxCount: number; // Max count allowed (from API)
            };
        };
    };
}

export enum JSBridgeTypes {
    ALLOW_THIRD_PARTY_INTENT = "ALLOW_THIRD_PARTY_INTENT",
    DO_DIGITAL_MENU_OPEN_MENU = "DO_DIGITAL_MENU_OPEN_MENU",
    DO_DIGITAL_MENU_QUICK_ACTION = "DO_DIGITAL_MENU_QUICK_ACTION",
    DO_DIGITAL_MENU_BILL_SUMMARY = "DO_DIGITAL_MENU_BILL_SUMMARY",
}

/**
 * Shape of the `data` field native sends inside the JS bridge payload for
 * Live Notification CTAs. `userJourney` is persisted to drive back-navigation;
 * `actionId`/`actionName` are only present for quick-action payloads.
 */
export interface ILiveNotificationBridgeData {
    actionId?: string;
    actionName?: string;
    userJourney?: string;
}

export interface DocumentWithViewTransition {
    startViewTransition?: (callback: () => void | Promise<void>) => void;
}

export * from "./cart";
export * from "../types/config";
